import { InjectionToken, ViewContainerRef } from "@angular/core";
import { AriaLivePoliteness } from "@angular/cdk/a11y";
import { Direction } from "@angular/cdk/bidi";

/** Injection token that can be used to access the data that was passed in to a alert. */
export const VDS_ALERT_DATA = new InjectionToken<any>("VdsAlertData");

/** Possible values for verticalPosition on VoAlertConfig. */
export type VdsAlertVerticalPosition = "top" | "bottom";

/** Possible alert classes on VoAlertConfig */
export type VdsAlertType = "warning" | "success" | "error" | "info";

/**
 * Configuration used when opening a snack-bar.
 */
export class VdsAlertConfig<D = any> {
    /** The politeness level for the MatAriaLiveAnnouncer announcement. */
    politeness?: AriaLivePoliteness = "assertive";

    /** Message to be announced by the MatAriaLiveAnnouncer */
    announcementMessage?: string = "";

    /** The view container to place the overlay for the alert into. */
    viewContainerRef?: ViewContainerRef;

    /** The length of time in milliseconds to wait before automatically dismissing the alert. */
    duration?: number = 5000;

    alertType?: VdsAlertType = "success";

    /** Text layout direction for the alert. */
    direction?: Direction;

    /** Data being injected into the child component. */
    data?: D | null = null;

    /** The vertical position to place the snack bar. */
    verticalPosition?: VdsAlertVerticalPosition = "top";
}
